import React from 'react';
import { Error } from './Error';

const SetupErrorComponent = () => {
  return <Error title={{ key: 'pages:errorBoundary.setUpError' }} />;
};

export default SetupErrorComponent;
